import api from './api';

class InventoryService {
  getItems(dataForm) {
    return api.post('/merchant/inventory/items', dataForm);
  }

  getDataFilter(dataForm) {
    return api.post('/merchant/inventory/get-data-filter', dataForm);
  }

  getStockTransfer(dataForm) {
    return api.post('/merchant/inventory/stock-transfer', dataForm);
  }

  createStockTransfer(dataForm) {
    return api.post('/merchant/inventory/create-stock-transfer', dataForm);
  }

  getDetailStockTransfer(dataForm) {
    return api.post('/merchant/inventory/stock-transfer-detail', dataForm);
  }

  receiveStockTransfer(dataForm) {
    return api.post('/merchant/inventory/receive-stock-transfer', dataForm);
  }

  stockInOut(dataForm) {
    return api.post('/merchant/inventory/stock-in-out', dataForm);
  }

  voidStockTransfer(dataForm) {
    return api.post('/merchant/inventory/void-stock-transfer', dataForm);
  }

  getStockMovementByItem(dataForm) {
    return api.post(`/merchant/inventory/item/${dataForm.item_id}/stock-movement`, dataForm);
  }

  importItems(dataForm) {
    return api.post('/merchant/inventory/import-items', dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  importTransferItems(dataForm) {
    return api.post('/merchant/inventory/import-transfer-items', dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  getInventoryProperties(id) {
    return api.get(`/merchant/inventory/item/${id}/get-properties`);
  }

  updateInventoryProperties(dataForm) {
    return api.post(`/merchant/inventory/update-properties`, dataForm);
  }

  showHideItem(id) {
    return api.get(`/merchant/inventory/item/${id}/show-hide`);
  }

  getStockMovementSummary(dataForm) {
    return api.post('/merchant/inventory/stock-movement-summary', dataForm);
  }
}

export default new InventoryService();
